export const handleUnit = (value: string, setter: (value: string) => void, type: number, setUnit: (number: number, type: number) => void) => {
    let number = parseFloat(value);
    if (value === "")
        setter("");
    if (isNaN(number)) return;
    setter(value);
    setUnit(number, type);
};
